import axios from 'axios'
import { Baseurl } from '../../service/apiService'
const BackupPage = () => {
  const handleImage = async () => {
    try{
      let queryUrl = new URLSearchParams()
      queryUrl.append('images',true)
      let response = await axios(`${Baseurl}/backup?${queryUrl.toString()}`,{responseType: 'blob'})
      if(response?.data){
        const blob = await response?.data;
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = "Images_Backup.zip"; 
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(url);
      }
    }catch(error){
      console.log('Error while downloading')
    }
  }
  const handleDb = async () => {
    try{  
      let queryUrl = new URLSearchParams()
      queryUrl.append('db',true)
      let response = await axios(`${Baseurl}/backup?${queryUrl.toString()}`,{responseType: 'blob'})
      if(response?.data){
        const blob = await response?.data;
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = "Database_Backup.zip"; 
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(url);
      }  
    }catch(error){
      console.log('Error while downloading')
    }   
  }
  return (
    <div>
      <h2 className='text-center'>Backup images & DB data</h2>
      <div className='d-flex justify-content-center p-3'>
        <button onClick={handleImage}>Download Images</button>
        <button onClick={handleDb}>Download DB</button>
      </div>
    </div>
  )
}
export default BackupPage